import { Injectable } from '@angular/core';
import { SOCIAL_NETWORK_SORT_ORDER } from 'core/shared-constants';
import { GetSocialNetworksGQL, SocialNetworkDetails, SocialNetworkDetailsFragment } from 'generated/graphql';
import { isNilOrEmpty } from 'helpers';
import { orderBy } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})

export class SocialNetworksService {
    static socialNetworks: SocialNetworkDetailsFragment[] = null;

    constructor(
        private _getSoicalNetworks: GetSocialNetworksGQL
    ) { }

    getSocialNetworks(): Observable<SocialNetworkDetailsFragment[]> {
        if (!isNilOrEmpty(SocialNetworksService.socialNetworks)) {
            return of(SocialNetworksService.socialNetworks);
          }
        return this._getSoicalNetworks.fetch().pipe(
            map(({ data }) => data.getSocialNetworks),
            tap((networks) => SocialNetworksService.socialNetworks = this._sortByLabel(networks)),
            map(() => SocialNetworksService.socialNetworks)
        );
    }

    static getSocialNetworkDetails(socialNetwork: string): SocialNetworkDetails.Fragment {
        if (isNilOrEmpty(SocialNetworksService.socialNetworks)) {
            return;
        }
        return SocialNetworksService.socialNetworks.find(network => network.id === socialNetwork);
    }

    private _sortByLabel(networks: SocialNetworkDetailsFragment[]): SocialNetworkDetailsFragment[] {
        return orderBy(networks, [(i) => SOCIAL_NETWORK_SORT_ORDER[i.id]], 'asc');
    }
}
